// extracted by mini-css-extract-plugin
export default {"container":"index-module__container--11yZ8","image":"index-module__image--2-8il","tip":"index-module__tip--cUMWv"};